import MainLayout from "@/components/layout/mainLayout";
import NewsAndArtikel from "./na";

const NewsPage = () => {
    return (
        <MainLayout>
            <NewsAndArtikel />
        </MainLayout>
    );
}

export default NewsPage;